import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  BASE_PATH_1_QUERY,
  BASE_PATH_2_QUERY,
  BASE_PATH_3_QUERY,
  EDIT_INDEX_QUERY,
  EDUCATION_EXP_QUERY,
  INDUSTRY_SLUG_QUERY,
  JOBTITLE_SLUG_QUERY,
  NEXT_SECTIONS_QUERY,
  RESUME_ID_QUERY,
  SEED_QUERY,
  WORK_EXP_QUERY,
} from '@glass/common/modules/pages/queryParams';
import keepObjKeys from '@glass/common/modules/utils/keepObjKeys';
import {
  RESUME_METADATA_COMPLETED_STEPS_FIELD,
  RESUME_METADATA_FIELD,
} from '@glass/web/modules/resumes/fieldKeys';
import useBuilderBasePath from '@glass/web/modules/resumes/router/resumeBuilderBasePath/useBuilderBasePath';

import getBuilderNextStepParams from '@glass/shared/components/Link/ResumeBuilderLink/getBuilderNextStepParams';
import { builderFirstStepParams } from '@glass/shared/modules/resumes/createBuilderFirstStepParams';
import { createSelectResumeCompletedSteps } from '@glass/shared/modules/resumes/resumesReducer';

const validQueryParams = [
  RESUME_ID_QUERY,
  BASE_PATH_2_QUERY,
  BASE_PATH_3_QUERY,
  NEXT_SECTIONS_QUERY,
  EDIT_INDEX_QUERY,
  SEED_QUERY,
  JOBTITLE_SLUG_QUERY,
  INDUSTRY_SLUG_QUERY,
  EDUCATION_EXP_QUERY,
  WORK_EXP_QUERY,
];

const useNextStepParams = (query, resume) => {
  const defaultBuilderBasePath = useBuilderBasePath();

  const { [RESUME_ID_QUERY]: resumeId, [BASE_PATH_2_QUERY]: section } = query || {};
  const selectResumeCompletedSteps = useMemo(
    () => createSelectResumeCompletedSteps(resumeId),
    [resumeId],
  );
  const completedStepsState = useSelector(selectResumeCompletedSteps);
  const completedSteps =
    resume?.[RESUME_METADATA_FIELD]?.[RESUME_METADATA_COMPLETED_STEPS_FIELD] || completedStepsState;

  return useMemo(() => {
    if (!section) {
      return builderFirstStepParams;
    }

    return getBuilderNextStepParams(
      {
        [BASE_PATH_1_QUERY]: defaultBuilderBasePath,
        ...keepObjKeys(query, validQueryParams),
      },
      completedSteps,
      resume,
    );
  }, [section, defaultBuilderBasePath, query, completedSteps, resume]);
};

export default useNextStepParams;
